import { css } from '@emotion/react'

const Styles = ({ colors }) => {
  const { scales: { grayShades } } = colors

  return ({
    card: css`
      border-radius: 1rem;
      width: 100%;
      box-sizing: border-box;
      max-width: 25.125rem;
      z-index: 1;
      position: relative;
      height: 39rem !important;
      #simulator{
        padding: 1.344rem 1.344rem 0px;
        overflow-y: scroll;
        height: 39rem !important;
        &::-webkit-scrollbar {
          width: 0rem;
        }
        &::-webkit-scrollbar-track {
          background: ${grayShades[0]};
        }
        &::-webkit-scrollbar-thumb {
          background: ${grayShades[0]};
        }
        & > div {
          overflow: hidden !important;
        }
      }
      #ionLoaderContainer{
        border-radius: 1rem;
      }
      @media(max-width: 768px){
        width: max-content;
      }
      @media(min-width: 320px) and (max-width: 400px){
        #simulator{
          border-radius: 0 !important;
        }
      }
    `
  })
}

export { Styles }
